import { render } from "./AdminOrderpushList.vue?vue&type=template&id=751a4345&scoped=true&ts=true&lang=true"
import script from "./AdminOrderpushList.vue?vue&type=script&lang=ts"
export * from "./AdminOrderpushList.vue?vue&type=script&lang=ts"

import "./AdminOrderpushList.vue?vue&type=style&index=0&id=751a4345&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751a4345"]])

export default __exports__